/* Game Night, the W.I.G. page: three small live demos from screen 6a of the
   2026-09-03 handoff. No state persists. The sport list and the hints are the
   two things the design left as template variables; the dares are the real
   Karaoke ladder from the app's deck, one rung per tier. */
(function () {
  var page = document.querySelector('.mpx-page');
  if (!page) return;

  /* 1. Tonight we're playing [dropdown] */
  var SPORTS = [
    ['Beer pong', 'One cup, called. Sink it. The next person sinks the same cup or takes a letter.'],
    ['Flip cup', 'One flip. Land it. The next person lands it or takes a letter.'],
    ['Darts', 'Call the number. Hit it. The next person hits it or takes a letter.'],
    ['Cornhole', 'In the hole, no bounce. The next person does it or takes a letter.'],
    ['Potato sack racing', 'Driveway to the mailbox, no falling. The next person makes it or takes a letter.'],
    ['Trash can free throws', 'From the couch, off the wall. The next person makes it or takes a letter.'],
    ['Bottle flipping', 'Onto the grill lid, cap up. The next person lands it or takes a letter.'],
    ['Office chair racing', 'Hallway, no hands on the wall. The next person makes it or takes a letter.'],
    ['Paper airplane distance', 'Past the kitchen island. The next person flies it or takes a letter.'],
    ['Sock toss into the hamper', 'Rolled, from the doorway. The next person sinks it or takes a letter.'],
    ['Putting into a coffee mug', 'Across the carpet, in one. The next person makes it or takes a letter.'],
    ['Literally anything', 'If someone can lose at it, it is a sport. The next person matches it or takes a letter.']
  ];
  var sportBtn = page.querySelector('[data-mpn-sport-btn]');
  var sportList = page.querySelector('[data-mpn-sport-list]');
  var sportName = page.querySelector('[data-mpn-sport-name]');
  var sportShot = page.querySelector('[data-mpn-sport-shot]');
  if (sportBtn && sportList) {
    sportList.innerHTML = SPORTS.map(function (s, i) {
      return '<button type="button" class="mpn-sport__opt' + (i === 1 ? ' is-on' : '') + '" role="option" data-i="' + i + '">' + s[0] + '</button>';
    }).join('');
    function openList(on) { sportList.hidden = !on; sportBtn.setAttribute('aria-expanded', on ? 'true' : 'false'); }
    sportBtn.addEventListener('click', function () { openList(sportList.hidden); });
    sportList.addEventListener('click', function (e) {
      var b = e.target.closest('[data-i]'); if (!b) return;
      var s = SPORTS[+b.getAttribute('data-i')];
      sportName.textContent = s[0]; sportShot.textContent = s[1];
      sportList.querySelectorAll('.mpn-sport__opt').forEach(function (o) { o.classList.toggle('is-on', o === b); });
      openList(false); sportBtn.focus();
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-mpn-sport]')) openList(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openList(false); });
  }

  /* 2. The live ink board: three misses spells the word */
  var board = page.querySelector('[data-mpn-board]');
  if (board) {
    var tiles = board.querySelectorAll('[data-mpn-tiles] .mpn-tile');
    var miss = board.querySelector('[data-mpn-miss]');
    var guilty = board.querySelector('[data-mpn-guilty]');
    var hint = board.querySelector('[data-mpn-hint]');
    var HINTS = [
      'Tap it. Nothing bad happens yet.',
      'That’s a W. Two more and it’s everyone’s problem.',
      'One letter away. The room can smell it.',
      'Every phone in the room just flipped to sentencing. Best sound a party makes.'
    ];
    var letters = 0;
    function paint() {
      tiles.forEach(function (t, i) { t.classList.toggle('is-on', i < letters); });
      var done = letters >= 3;
      miss.hidden = done; guilty.hidden = !done;
      hint.textContent = HINTS[letters];
      if (done && navigator.vibrate) { try { navigator.vibrate([120, 60, 120]); } catch (e) {} }
    }
    miss.addEventListener('click', function () { letters = Math.min(3, letters + 1); paint(); });
    board.querySelector('[data-mpn-reset]').addEventListener('click', function () { letters = 0; paint(); });
    paint();
  }

  /* 3. The tier picker: one sample dare per tier, the title it pays out */
  var picker = page.querySelector('[data-mpn-picker]');
  if (picker) {
    var TIERS = [
      ['MEEK', 'Fetches every snack and drink refill for the rest of the night. Tosses the tail over one shoulder before each delivery. Answers to "garçon."', 'WUSSY'],
      ['MISCHIEF', 'Orders at a drive-thru in it, in character, no laughing. Asks if they do a mullet discount. Waits for the answer.', 'BUSINESS CASUAL'],
      ['MOTHERF*CKER', 'Takes the room to a sit-down restaurant in it, orders for the whole table in character, sends one dish back "for the hair," and asks the server to take the photo.', 'BIG W.I.G.']
    ];
    var label = picker.querySelector('[data-mpn-tier-label]');
    var dare = picker.querySelector('[data-mpn-tier-dare]');
    var pays = picker.querySelector('[data-mpn-tier-pays]');
    picker.querySelectorAll('[data-mpn-tier]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = TIERS[+b.getAttribute('data-mpn-tier')];
        picker.querySelectorAll('[data-mpn-tier]').forEach(function (o) { o.classList.toggle('is-on', o === b); });
        label.textContent = t[0]; dare.textContent = t[1];
        pays.innerHTML = t[2] === 'WUSSY' ? '<span class="mpn-wussy"><span class="w">W</span>USSY<span class="p">P</span></span>' : t[2];
      });
    });
  }
})();
